import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import {
  StyledData,
  StyledDataItem,
  StyledDataList,
  StyledDataTitle,
  StyledDataValue,
  StyledHero,
  StyledHeroContainer,
  StyledHeroDesc,
  StyledHeroTitle
} from './SectionHero.styled';
import { SectionHeroProps } from './SectionHero.types';

const SectionHero: React.FC<SectionHeroProps> = ({
  background,
  backgroundSm,
  title,
  desc,
  data
}) => {
  const { t } = useI18n('developer-career-report-2023');

  return (
    <StyledHero>
      <img src={background} alt="" className="desktop" />
      <img src={backgroundSm} alt="" className="mobile" />
      <StyledHeroContainer>
        <StyledHeroTitle as="h2">
          <HtmlTrans ns="developer-career-report-2023" i18nKey={title} />
        </StyledHeroTitle>
        {desc && (
          <StyledHeroDesc>
            <HtmlTrans ns="developer-career-report-2023" i18nKey={desc} />
          </StyledHeroDesc>
        )}
        {data && (
          <StyledData>
            <StyledDataTitle>
              {t('mandecar23.key-points-title')}
            </StyledDataTitle>
            <StyledDataList>
              {data.map((item, index) => (
                <StyledDataItem key={index}>
                  <StyledDataValue>{item.value}</StyledDataValue>
                  <p>
                    <HtmlTrans
                      ns="developer-career-report-2023"
                      i18nKey={item.desc}
                    />
                  </p>
                </StyledDataItem>
              ))}
            </StyledDataList>
          </StyledData>
        )}
      </StyledHeroContainer>
    </StyledHero>
  );
};

export default SectionHero;
